module.exports = __webpack_public_path__ + "img/logo.381c224e.png";